const plantData = [
  {
    id: "1",
    frequency: "shrub",
    species: "Hibiscus",
    nickname: "Henrietta",
    diameter: "5",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT66kBCJQb6rlqtcw5OnJnZbKPsT8e23I-yVg&usqp=CAU"
  },
  {
    id: "2",
    frequency: "ground cover",
    species: "Astrophytum",
    nickname: "Pear",
    diameter: "1",
    image: "https://cdn.shopify.com/s/files/1/0968/5384/products/3ec32ced-0361-5ad7-a920-28e867d17118_1800x1800.jpg?v=1569270748"
  },
  {
    id: "3",
    frequency: "ground cover",
    species: "Bunchberry",
    nickname: "Fruitloop",
    diameter: "3",
    image: "https://www.gardenia.net/storage/app/public/uploads/images/detail/jNHWjDt2fLFwiGOT9LLf4tF9t6OvoO5EqNydyvge.jpeg"
  },
  {
    id: "4",
    frequency: "shrub",
    species: "Forsythia",
    nickname: "Bill",
    diameter: "4",
    image: "https://www.thespruce.com/thmb/Of-Qn-UHIXEqr44x3ppLg20Ia60=/960x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/forsythia-bushes-plants-that-herald-spring-2131177-06-555249d55dd3490e9febf095ec322a1f.jpg"
  },
  {
    id: "5",
    frequency: "tree",
    species: "Maple",
    nickname: "Syrup",
    diameter: "6",
    image: "https://cdn11.bigcommerce.com/s-f74ff/images/stencil/1280x1280/products/9840/28918/tree-seedlings-sugar-maple-seedlings-sugar-maple-seedlings__09893.1600792911.jpg?c=2"}
]

export default plantData